import $ from 'jquery';
import 'jquery.cookie';
import URI from 'urijs';

import _ from './underscore_extend';

import Application from './application';

var bigListOfUserAgentsRegexp,
    forceDesktopCookieName,
    injectElementWithStyles,
    checkForceDesktopCookie,
    maxMobileWidthMediaQuery,
    mobile,
    smallListOfUserAgentsRegexp,
    smallListOfUserAgentsExcludesRegexp,
    testMediaQuery,
    toogleForceDesktopCookie,
    mod = 'modernizr';

/* User agents RegExpes */

smallListOfUserAgentsRegexp = new RegExp('(?:' + ([
    'up.browser', 'up.link', 'mmp', 'symbian', 'smartphone', 'midp',
    'wap', 'phone', 'windows ce', 'pda', 'mobile', 'mini', 'palm',
    'netfront', 'opera mobi', 'android', 'xoom', 'sch-i800',
    'playbook', 'tablet', 'kindle', 'mobile safari', 'wp7'
]).join('|') + ')', 'i');

smallListOfUserAgentsExcludesRegexp = new RegExp('(?:' + ([
    'ipad'
]).join('|') + ')', 'i');

bigListOfUserAgentsRegexp = new RegExp('^(?:' + ([
    'w3c ', 'acs-', 'alav', 'alca', 'amoi', 'audi',
    'avan', 'benq', 'bird', 'blac', 'blaz', 'brew',
    'cell', 'cldc', 'cmd-', 'dang', 'doco', 'eric',
    'hipt', 'inno', 'ipaq', 'java', 'jigs', 'kddi',
    'keji', 'leno', 'lg-c', 'lg-d', 'lg-g', 'lge-',
    'maui', 'maxo', 'midp', 'mits', 'mmef', 'mobi',
    'mot-', 'moto', 'mwbp', 'nec-', 'newt', 'noki',
    'xda',  'palm', 'pana', 'pant', 'phil', 'play',
    'port', 'prox', 'qwap', 'sage', 'sams', 'sany',
    'sch-', 'sec-', 'send', 'seri', 'sgh-', 'shar',
    'sie-', 'siem', 'smal', 'smar', 'sony', 'sph-',
    'symb', 't-mo', 'teli', 'tim-', 'tosh', 'tsm-',
    'upg1', 'upsi', 'vk-v', 'voda', 'wap-', 'wapa',
    'wapi', 'wapp', 'wapr', 'webc', 'winw', 'winw',
    'xda-'
]).join('|') + ')', 'i');

maxMobileWidthMediaQuery = 'all and (max-width: 799px)';


injectElementWithStyles = function(rule, callback, nodes, testnames) {
    var style, ret, node, docOverflow,
        div = document.createElement('div'),
        body = document.body,
        fakeBody = body || document.createElement('body');

    if (parseInt(nodes, 10)) {
        while (nodes--) {
            node = document.createElement('div');
            node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
            div.appendChild(node);
        }
    }
    style = ['&#173;','<style id="s', mod, '">', rule, '</style>'].join('');
    div.id = mod;
    (body ? div : fakeBody).innerHTML += style;
    fakeBody.appendChild(div);
    if (!body) {
        fakeBody.style.background = '';
        fakeBody.style.overflow = 'hidden';
        docOverflow = docElement.style.overflow;
        docElement.style.overflow = 'hidden';
        docElement.appendChild(fakeBody);
    }
    ret = callback(div, rule);
    if (!body) {
        fakeBody.parentNode.removeChild(fakeBody);
        docElement.style.overflow = docOverflow;
    } else {
        div.parentNode.removeChild(div);
    }
    return !!ret;
};

testMediaQuery = function(mq) {
    var matchMedia = window.matchMedia || window.msMatchMedia,
        positionAbsolute;

    if (matchMedia) {
        return matchMedia(mq).matches;
    }
    injectElementWithStyles('@media ' + mq + ' { #' + mod + ' { position: absolute; } }', function(node) {
        positionAbsolute = (window.getComputedStyle ? getComputedStyle(node, null) : node.currentStyle)['position'] == 'absolute';
    });
    return positionAbsolute;
};

toogleForceDesktopCookie = function(cookieName) {
    var value = $.cookie(cookieName) ? null : true,
        options = {
            path: '/'
        };

    $.cookie(cookieName, value, options);
};

mobile = function(argument) {
    var docElement = document.documentElement,
        currentAgent = navigator.userAgent,
        isMobile = smallListOfUserAgentsRegexp.test(currentAgent),
        useTouchDevice = window.ontouchstart !== undefined,
        forceDesktopCookieName = _.extract('Settings.MOBILE_BROWSER_FORCE_DESKTOP_COOKIE_NAME', undefined, true),
        forceDesktop = $.cookie(forceDesktopCookieName),
        query = URI.parseQuery(window.location.search),
        forceMobile = query.mobile === '1',
        settings = window.Settings.Mobile = {},
        useAdaptive = testMediaQuery(maxMobileWidthMediaQuery),
        useMobile, mobileDetectedResult;

    if (!isMobile) {
        isMobile = bigListOfUserAgentsRegexp.test(currentAgent);
    }
    if (isMobile) {
        isMobile = !smallListOfUserAgentsExcludesRegexp.test(currentAgent);
    }
    if (isMobile) {
        isMobile = useAdaptive;
    }

    useMobile = (isMobile  || forceMobile) && !forceDesktop;

    settings.isMobile = isMobile;
    settings.forceDesktop = forceDesktop;
    settings.useMobile = useMobile;
    settings.useAdaptive = useAdaptive;
    settings.useTouchDevice = useTouchDevice;

    Application.on('mobile-browser-force-desktop', function() {
        toogleForceDesktopCookie(forceDesktopCookieName);
        window.location.href = window.location.href;
    });

    mobileDetectedResult = {
        detected: isMobile,
        forceDesktop: forceDesktop,
        forceMobile: forceMobile,
        useMobile: useMobile,
        useAdaptive: useAdaptive,
        useTouchDevice: useTouchDevice
    };

    Application.trigger('mobile-browser-detected', mobileDetectedResult);
    Application.trigger('mobile-browser-detected-onload', mobileDetectedResult);

    return mobileDetectedResult;
};

export default mobile;



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/lib/mobile.js